<script lang="ts" setup>
import { ref, watch, computed } from 'vue';

import type { Nullable } from '@immersive-tech/viewer-engine';

interface IProps {
  mobileOffset: number | '';
}

interface IEmits {
  (e: 'change', value: Nullable<number>): unknown;
}

const emit = defineEmits<IEmits>();
const props = defineProps<IProps>();

const mobileOffset = ref(props.mobileOffset);

const parsedMobileOffset = computed<Nullable<number>>(() => {
  if (mobileOffset.value === '') return null;

  return mobileOffset.value;
});

const mobileOffsetWatcher = () => {
  emit('change', parsedMobileOffset.value);
};

watch(mobileOffset, mobileOffsetWatcher);
</script>

<template>
  <input
    id="perspective-offset"
    v-model="mobileOffset"
    class="border text-xs p-1"
    type="number"
    min="0"
    max="360"
    step="0.01"
  >
</template>
